// my-purchases-graphql constants
import PropTypes from 'prop-types';

import config from 'js/app/config';

import { REFUND_POLICY_LINK } from 'bundles/about/AboutConstants';
import SettingsConstants from 'bundles/account-settings/constants/SettingsConstants';
import PaymentProcessorTypes from 'bundles/payments/common/PaymentProcessorTypes';

export const paymentProcessors = PaymentProcessorTypes;
export const nonRefundablePaymentProcessors = [paymentProcessors.appleInapp];
export const noMoneyPaymentProcessors = [paymentProcessors.financialAid, paymentProcessors.zeroDollar];

export const HELP_CENTER_LINK = 'https://learner.coursera.help/';
export const SUBSCRIPTIONS_HELP_LINK = 'https://learner.coursera.help/hc/articles/216348103-Coursera-subscriptions';
export { REFUND_POLICY_LINK };
export const BROWSE_CATALOG_LINK = `${config.url.base}browse`;
export const PAYMENT_METHOD_SETTINGS_LINK = `${config.url.base}account-settings#${SettingsConstants.TopSections.PAYMENT}`;
export const MY_PURCHASES_TRANSACTIONS_PATH = `/my-purchases/transactions`;
export const MY_PURCHASES_TRANSACTIONS_LINK = `${config.url.base}my-purchases/transactions`;

export const getRefundSuccessPath = (userProductTransactionId: $TSFixMe, cartId: $TSFixMe) =>
  `/my-purchases/get-refund/${userProductTransactionId}/${cartId}/success`;

export const getTrackYourRefundPath = (userProductTransactionId: $TSFixMe, cartId: $TSFixMe) =>
  `/my-purchases/track-refund/${userProductTransactionId}/${cartId}`;

export const getRefundErrorPath = `/my-purchases/get-refund/error`;

export const paymentShape = PropTypes.shape({
  productItemDetails: PropTypes.shape({
    productName: PropTypes.string.isRequired,
    productUrl: PropTypes.string.isRequired,
    expiresAt: PropTypes.number,
    courseId: PropTypes.string,
  }),
  productId: PropTypes.string.isRequired,
  productType: PropTypes.string.isRequired,
  isRefundable: PropTypes.bool.isRequired,
  receiptAvailable: PropTypes.bool.isRequired,
  paymentMethod: PropTypes.string.isRequired,
  isGringotts: PropTypes.bool.isRequired,
  amount: PropTypes.number.isRequired,
  currencyId: PropTypes.number.isRequired,
  cartItemId: PropTypes.number,
  cartId: PropTypes.number,
  countryIsoCode: PropTypes.string,
  expiresAt: PropTypes.number,
  refundDeadline: PropTypes.number,
});
